import { SwitchFilter } from '../../../../../shared/types/modules/switch';

export const initialValues: SwitchFilter = {
    callId: '',
    account: '',
    typification1: '',
    typification2: '',
    user: [],
    endCreatedAt: undefined,
    startCreatedAt: undefined,
};
